import React, { useState, useEffect, useRef } from "react";
import { AGENCY_LICENSE_LIST } from "../../../constants/ApiPaths";
import { authHeader } from "../../../functions/CoreFunctions";
import API from "../../../redux/actions/API";
import {
  Button,
  Row,
  Col,
  Container,
  Badge,
  Card,
  UncontrolledCollapse,
  CardBody,
  Input,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Dropdown,
} from "reactstrap";
import CustomPageLoading from "../../CustomComponents/CustomPageLoading";
import moment from "moment";
import Pagination from "../../common/Pagination";
import { Link } from "react-router-dom";
import { CustomAlertMessage } from "../../../functions/CustomFunctions";
import { useSnackbar } from "notistack";
import { getAgencyId } from "../../common/CommonFunctions";
import userLogo from "../../../images/user logo.png";
import { CSVLink } from "react-csv";
import generatePDF from "../../../components/Agency/Report/LicenseReportGenerte";
import { useLocation } from "react-router";
import { Box, Tab, Tabs } from "@mui/material";

//Agency ID

function LicenseList() {
  const [details, setDetails] = useState([]);
  const [customerDetails, setCustomerDetails] = useState([]);
  const [loading, setLoading] = useState(false);
  const rowperpage = 9;
  const [currentpage, setCurrentPage] = useState(0);
  const [customerCurrentpage, setCustomerCurrentPage] = useState(0);
  const [totalrecords, setTotalRecords] = useState(0);
  const [customertotalrecords, setCustomerTotalRecords] = useState(0);
  const [licenseStatus, setLicenseStatus] = useState("");
  const [customerlicenseStatus, setCustomerLicenseStatus] = useState("");
  const [email, setEmail] = useState();
  const [customerEmail, setCustomerEmail] = useState();
  const { enqueueSnackbar } = useSnackbar();
  const [dropdownOpen, setdropdownOpen] = useState(false);
  const [customerdropdownOpen, setcustomerdropdownOpen] = useState(false);
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const dashboard = queryParams.get("dashboard");

  const togglerRef = useRef(null);
  useEffect(() => {
    if (dashboard) {
      setLicenseStatus(dashboard);
      if (togglerRef.current) {
        togglerRef.current.click();
      }
    }
  }, [dashboard]);

  const headers = [
    { label: "Name", key: "userName" },
    { label: "Email", key: "email" },
    { label: "Plan Amount", key: "planAmount" },
    { label: "Valid From Date", key: "validFromDate" },
    { label: "Valid to Date", key: "validToDate" },
    { label: "Type of License", key: "typeofLicense" },
    { label: "License Issued Date", key: "licenseIssuedDate" },
    { label: "license Status", key: "licenseStatus" },
  ];
  const toggle = () => {
    setdropdownOpen(!dropdownOpen);
  };
  const customertoggle = () => {
    setcustomerdropdownOpen(!dropdownOpen);
  };
  const Export = () => {
    generatePDF(details);
  };
   const CustomerExport = () => {
    generatePDF(customerDetails);
  };

  const getLicenseList = async (e) => {
    setLoading(true);
    const config = {
      method: "GET",
      url: AGENCY_LICENSE_LIST,
      headers: authHeader(),
      params: {
        agencyId: getAgencyId(),
        offset: currentpage,
        count: rowperpage,
        licenseStatus: dashboard ? dashboard : licenseStatus,
        email: email,
        isKennelLicense: false,
        isAgencyLicense: 1
      },
    };
    try {
      const response = await API(config);
      const { status, data, totalCount } = response.data;
      if (status === "Success") {
        setDetails(data);
        setTotalRecords(totalCount);
      }
    } catch (error) {
      if (error.response) {
        const { data } = error.response;
        CustomAlertMessage(data.message, "error", enqueueSnackbar);
      }
    } finally {
      setLoading(false);
    }
  };
const getCustomerLicenseList = async (e) => {
    setLoading(true);
    const config = {
      method: "GET",
      url: AGENCY_LICENSE_LIST,
      headers: authHeader(),
      params: {
        agencyId: getAgencyId(),
        offset: customerCurrentpage,
        count: rowperpage,
        licenseStatus: dashboard ? dashboard : customerlicenseStatus,
        email: customerEmail,
        isKennelLicense: false,
        isAgencyLicense: 0
      },
    };
    try {
      const response = await API(config);
      const { status, data, totalCount } = response.data;
      if (status === "Success") {
        setCustomerDetails(data);
        setCustomerTotalRecords(totalCount);
      }
    } catch (error) {
      if (error.response) {
        const { data } = error.response;
        CustomAlertMessage(data.message, "error", enqueueSnackbar);
      }
    } finally {
      setLoading(false);
    }
  };
  const onPageChange = (page) => {
    setCurrentPage(page - 1);
  };
 const onCustomerPageChange = (page) => {
    setCustomerCurrentPage(page - 1);
  };
  const onHandleEmail = (e) => {
    const { value } = e.target;
    setEmail(value);
  };
 const onCustomerHandleEmail = (e) => {
    const { value } = e.target;
    setCustomerEmail(value);
  };
  const getLicenseStatus = (e) => {
    setCurrentPage(0);
    setLicenseStatus(e.target.value);
  };
 const getCustomerLicenseStatus = (e) => {
    setCustomerCurrentPage(0);
    setCustomerLicenseStatus(e.target.value);
  };
  const Clear = () => {
    setLicenseStatus("");
    setEmail("");
  };
    const CustomerClear = () => {
    setCustomerLicenseStatus("");
    setCustomerEmail("");
  };

  useEffect(() => {
    setTimeout(() => {
      getLicenseList();
      getCustomerLicenseList();
    }, 500);
  }, [currentpage, licenseStatus, email, customerCurrentpage, customerlicenseStatus, customerEmail]);

  const [value, setValue] = useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
    handleClick(newValue === 0 ? 'agency' : 'customer'); // Call your existing handler
  };

  const handleClick = (type) => {
  };
  return (
    <div>
      <div className="agency-wrapper">
        <Container fluid>
          <div className="page-title">
           <Box sx={{ width: '100%' }}>
                      <Tabs
                    value={value}
                    onChange={handleChange}
                    textColor="primary"
                    indicatorColor="primary"
                    aria-label="Agency and Customer Tabs"
                    sx={{ gap: '2rem'}}
                  >
                    <Tab label="Agency License" sx={{ width: '200px', fontSize: '18px', fontWeight: '700', color: '#212529', textTransform: 'none'}} />
                    <Tab label="Customer License" sx={{  width: '200px', fontSize: '18px', fontWeight: '700', color: '#212529', textTransform: 'none'}} />
                  </Tabs>
                  <Box sx={{ mt: 6 }}>
                    {value === 0 && (
                      <div>
                          <div className="top-btn">
                                        <Dropdown isOpen={dropdownOpen} toggle={toggle}>
                                          <DropdownToggle color="danger" caret>
                                            Export
                                          </DropdownToggle>
                                          <DropdownMenu>
                                            <DropdownItem onClick={Export}>PDF</DropdownItem>
                                            <DropdownItem>
                                              <CSVLink
                                                filename={"License_report.csv"}
                                                data={details}
                                                headers={headers}
                                              >
                                                CSV
                                              </CSVLink>
                                            </DropdownItem>
                                          </DropdownMenu>
                                        </Dropdown>
                                        <Button color="link" id="toggler" innerRef={togglerRef}>
                                          <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="14.371"
                                            height="14.371"
                                            viewBox="0 0 14.371 14.371"
                                          >
                                            <path
                                              id="Icon_awesome-filter"
                                              data-name="Icon awesome-filter"
                                              d="M13.7,0H.674A.674.674,0,0,0,.2,1.15L5.389,6.342v5.784a.674.674,0,0,0,.287.552l2.246,1.571a.674.674,0,0,0,1.06-.552V6.342L14.173,1.15A.674.674,0,0,0,13.7,0Z"
                                              fill="#1b3e6f"
                                            />
                                          </svg>
                                        </Button>
                             </div>
                               <Row>
            <Col sm="12" xl={{ size: 6, offset: 3 }}>
              <UncontrolledCollapse className="mt-4" toggler="#toggler">
                <Card>
                  <CardBody>
                    <Row>
                      <Col md="4">
                        <Input
                          type="text"
                          onChange={onHandleEmail}
                          value={email}
                          name="Email"
                          placeholder="Search Email"
                        />
                      </Col>
                      <Col md="4">
                        <Input
                          type="select"
                          name="License Status"
                          value={licenseStatus}
                          onChange={(e) => getLicenseStatus(e)}
                        >
                          <option value="">Change Status</option>
                          <option value="Pending">Pending</option>
                          <option value="Cancelled">Cancelled</option>
                          <option value="Rejected">Rejected</option>
                          <option value="License Generated">
                            License Generated
                          </option>
                          <option value="License Approved">
                            License Approved
                          </option>
                          <option value="License Issued">License Issued</option>
                          <option value="Payment Completed">
                            Payment Completed
                          </option>
                           <option value="Pay with Agency">
                            Pay with Agency
                          </option>
                        </Input>
                      </Col>
                      <Col md="4">
                        <Button color="danger" onClick={Clear} block>
                          Clear
                        </Button>
                      </Col>
                    </Row>
                  </CardBody>
                </Card>
              </UncontrolledCollapse>
            </Col>
          </Row>

          <Row className="mt-4">
            {loading ? <CustomPageLoading /> : ""}
            {loading ? (
              ""
            ) : details.length === 0 ? (
              <Col>
                <center>No Records Found</center>
              </Col>
            ) : (
              details.map((data) => {
                const {
                  planName,
                  licenseStatus,
                  dogImageUrl,
                  dogName,
                  licenseIssuedDate,
                  email,
                  licensePlanId,
                  userName,
                  planAmount,
                  dogLicenseId,
                  planDuration,
                  isLifeTimePlan,
                } = data;

                return (
                  <Col md="6" lg="6" xl="4" className="mb-3" key={dogLicenseId}>
                    <div className="license-box">
                      <span className="date">
                        {!!licenseIssuedDate &&
                          moment(licenseIssuedDate).format("MM/DD/YYYY")}
                      </span>

                      <Link
                        className="viewBtn"
                        to={{
                          pathname: `${"/agency/view-license"}/${licensePlanId}/${dogLicenseId}`,
                        }}
                      >
                        <Button
                          className="action-item"
                          color="primary"
                          size="sm"
                        >
                          View
                        </Button>
                      </Link>

                      <div className="dogImg">
                        <img
                          src={dogImageUrl ? dogImageUrl : userLogo}
                          alt=""
                        />
                      </div>

                      <h4>{planName ? planName : "N/A"}</h4>

                      <div className="mt-4">
                        <div>
                          <div className="row align-items-center">
                            <div className="col">
                              <h6 className="text-sm mb-0">Pet Name</h6>
                            </div>
                            <div className="col-auto">
                              <span className="text-sm">
                                {dogName ? dogName : "N/A"}
                              </span>
                            </div>
                          </div>
                          <hr className="my-2" />
                          <div className="row align-items-center">
                            <div className="col">
                              <h6 className="text-sm mb-0">User</h6>
                            </div>
                            <div className="col-auto">
                              <span className="text-sm">
                                {" "}
                                {userName ? userName : "N/A"}
                              </span>
                            </div>
                          </div>
                          <hr className="my-2" />
                          <div className="row align-items-center">
                            <div className="col">
                              <h6 className="text-sm mb-0">Email</h6>
                            </div>
                            <div className="col-auto">
                              <span className="text-sm">
                                {email ? email : "N/A"}
                              </span>
                            </div>
                          </div>
                          <hr className="my-2" />
                        </div>
                      </div>

                      <div className="plan">
                        <span>
                          $
                          {planAmount
                            ? parseFloat(planAmount).toFixed(2)
                            : "N/A"}{" "}
                          /{" "}
                          {isLifeTimePlan
                            ? "Lifetime plan"
                            : parseInt(planDuration) * 12 + "month"}
                        </span>
                      </div>
                      <Badge
                        className={
                          licenseStatus === "License Issued"
                            ? "badge-pay-complete"
                            : licenseStatus === "Pending"
                            ? "badge-success-pen"
                            : licenseStatus === "License Approved"
                            ? "badge-success-apr"
                            : licenseStatus === "Rejected"
                            ? "badge-danger-soft"
                            : licenseStatus === "Payment Completed"
                            ? "badge-primary-soft"
                            : licenseStatus === "License Generated"
                            ? "badge-success-gen"
                            : licenseStatus === "Cancelled"
                            ? "badge-danger-soft"
                            : ""
                        }
                      >
                        {licenseStatus}
                      </Badge>
                    </div>
                  </Col>
                );
              })
            )}
          </Row>
          <div className="d-flex flex-row py-4 justify-content-end">
            <Pagination
              itemClass="page-item"
              linkClass="page-link"
              itemsCountPerPage={rowperpage}
              totalItemsCount={totalrecords}
              activePage={currentpage + 1}
              onChange={onPageChange}
            />
          </div>
             </div>
                    )}
                    {value === 1 && (
                      <div>
                          <div className="top-btn">
                                        <Dropdown isOpen={customerdropdownOpen} toggle={customertoggle}>
                                          <DropdownToggle color="danger" caret>
                                            Export
                                          </DropdownToggle>
                                          <DropdownMenu>
                                            <DropdownItem onClick={CustomerExport}>PDF</DropdownItem>
                                            <DropdownItem>
                                              <CSVLink
                                                filename={"License_report.csv"}
                                                data={customerDetails}
                                                headers={headers}
                                              >
                                                CSV
                                              </CSVLink>
                                            </DropdownItem>
                                          </DropdownMenu>
                                        </Dropdown>
                                        <Button color="link" id="toggler" innerRef={togglerRef}>
                                          <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="14.371"
                                            height="14.371"
                                            viewBox="0 0 14.371 14.371"
                                          >
                                            <path
                                              id="Icon_awesome-filter"
                                              data-name="Icon awesome-filter"
                                              d="M13.7,0H.674A.674.674,0,0,0,.2,1.15L5.389,6.342v5.784a.674.674,0,0,0,.287.552l2.246,1.571a.674.674,0,0,0,1.06-.552V6.342L14.173,1.15A.674.674,0,0,0,13.7,0Z"
                                              fill="#1b3e6f"
                                            />
                                          </svg>
                                        </Button>
                             </div>
                               <Row>
            <Col sm="12" xl={{ size: 6, offset: 3 }}>
              <UncontrolledCollapse className="mt-4" toggler="#toggler">
                <Card>
                  <CardBody>
                    <Row>
                      <Col md="4">
                        <Input
                          type="text"
                          onChange={onCustomerHandleEmail}
                          value={customerEmail}
                          name="Email"
                          placeholder="Search Email"
                        />
                      </Col>
                      <Col md="4">
                        <Input
                          type="select"
                          name="License Status"
                          value={customerlicenseStatus}
                          onChange={(e) => getCustomerLicenseStatus(e)}
                        >
                          <option value="">Change Status</option>
                          <option value="Pending">Pending</option>
                          <option value="Cancelled">Cancelled</option>
                          <option value="Rejected">Rejected</option>
                          <option value="License Generated">
                            License Generated
                          </option>
                          <option value="License Approved">
                            License Approved
                          </option>
                          <option value="License Issued">License Issued</option>
                          <option value="Payment Completed">
                            Payment Completed
                          </option>
                        </Input>
                      </Col>
                      <Col md="4">
                        <Button color="danger" onClick={CustomerClear} block>
                          Clear
                        </Button>
                      </Col>
                    </Row>
                  </CardBody>
                </Card>
              </UncontrolledCollapse>
            </Col>
          </Row>

          <Row className="mt-4">
            {loading ? <CustomPageLoading /> : ""}
            {loading ? (
              ""
            ) : customerDetails.length === 0 ? (
              <Col>
                <center>No Records Found</center>
              </Col>
            ) : (
              customerDetails.map((data) => {
                const {
                  planName,
                  licenseStatus,
                  dogImageUrl,
                  dogName,
                  licenseIssuedDate,
                  email,
                  licensePlanId,
                  userName,
                  planAmount,
                  dogLicenseId,
                  planDuration,
                  isLifeTimePlan,
                } = data;

                return (
                  <Col md="6" lg="6" xl="4" className="mb-3" key={dogLicenseId}>
                    <div className="license-box">
                      <span className="date">
                        {!!licenseIssuedDate &&
                          moment(licenseIssuedDate).format("MM/DD/YYYY")}
                      </span>

                      <Link
                        className="viewBtn"
                        to={{
                          pathname: `${"/agency/view-license"}/${licensePlanId}/${dogLicenseId}`,
                        }}
                      >
                        <Button
                          className="action-item"
                          color="primary"
                          size="sm"
                        >
                          View
                        </Button>
                      </Link>

                      <div className="dogImg">
                        <img
                          src={dogImageUrl ? dogImageUrl : userLogo}
                          alt=""
                        />
                      </div>

                      <h4>{planName ? planName : "N/A"}</h4>

                      <div className="mt-4">
                        <div>
                          <div className="row align-items-center">
                            <div className="col">
                              <h6 className="text-sm mb-0">Pet Name</h6>
                            </div>
                            <div className="col-auto">
                              <span className="text-sm">
                                {dogName ? dogName : "N/A"}
                              </span>
                            </div>
                          </div>
                          <hr className="my-2" />
                          <div className="row align-items-center">
                            <div className="col">
                              <h6 className="text-sm mb-0">User</h6>
                            </div>
                            <div className="col-auto">
                              <span className="text-sm">
                                {" "}
                                {userName ? userName : "N/A"}
                              </span>
                            </div>
                          </div>
                          <hr className="my-2" />
                          <div className="row align-items-center">
                            <div className="col">
                              <h6 className="text-sm mb-0">Email</h6>
                            </div>
                            <div className="col-auto">
                              <span className="text-sm">
                                {email ? email : "N/A"}
                              </span>
                            </div>
                          </div>
                          <hr className="my-2" />
                        </div>
                      </div>

                      <div className="plan">
                        <span>
                          $
                          {planAmount
                            ? parseFloat(planAmount).toFixed(2)
                            : "N/A"}{" "}
                          /{" "}
                          {isLifeTimePlan
                            ? "Lifetime plan"
                            : parseInt(planDuration) * 12 + "month"}
                        </span>
                      </div>
                      <Badge
                        className={
                          licenseStatus === "License Issued"
                            ? "badge-pay-complete"
                            : licenseStatus === "Pending"
                            ? "badge-success-pen"
                            : licenseStatus === "License Approved"
                            ? "badge-success-apr"
                            : licenseStatus === "Rejected"
                            ? "badge-danger-soft"
                            : licenseStatus === "Payment Completed"
                            ? "badge-primary-soft"
                            : licenseStatus === "License Generated"
                            ? "badge-success-gen"
                            : licenseStatus === "Cancelled"
                            ? "badge-danger-soft"
                            : ""
                        }
                      >
                        {licenseStatus}
                      </Badge>
                    </div>
                  </Col>
                );
              })
            )}
          </Row>
          <div className="d-flex flex-row py-4 justify-content-end">
            <Pagination
              itemClass="page-item"
              linkClass="page-link"
              itemsCountPerPage={rowperpage}
              totalItemsCount={customertotalrecords}
              activePage={customerCurrentpage + 1}
              onChange={onCustomerPageChange}
            />
          </div>
                      </div>
                    )}
                    </Box>
                    </Box>
                    </div>
        </Container>
      </div>
    </div>
  );
}

export default LicenseList;
